import Location from '../components/Location'
import Contact from '../components/Contact'

export default function ContactPage() {
  return (
    <>
    <div className='pt-28'></div>
      <Contact />
      <Location />
    </>
  )
}
